import mixitup from 'mixitup';
import mixitupPagination from '../mixitup-pagination';
import { scrollPageTo } from '../utils';

mixitup.use(mixitupPagination);

export default class PostsFilter {
	constructor(el) {
		this.el = el;
		this.breakpoint = window.matchMedia('(max-width:576px)');

		const perPage = this.el.dataset.postPerPage;
		const target = this.el.dataset.targetSelector;
		let options = {
			animation: {
				enable: false,
			},
			selectors: {
				target: target ? target : '.c-card',
			},
			callbacks: {
				onMixEnd: (state) => {
					scrollPageTo(this.el, 500, -200);
				},
			},
		};
		let paginationOptions = {
			pagination: {
				limit: perPage ? perPage : 9,
			},
			templates: {
				pagerPrev:
					'<button aria-label="Vorige pagina" type="button" class="${classNames} c-back-button c-back-button--pagination" data-page="prev"><svg class="c-back-button__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g transform="matrix(-1 0 0 1 48 0)" fill="none" fill-rule="evenodd"><circle class="c-back-button__circle" cx="24" cy="24" r="24"/><path class="c-back-button__arrow" fill-rule="nonzero" d="M34 23H17.8l5.6-5.6L22 16l-8 8 8 8 1.4-1.4-5.6-5.6H34z"/></g></svg></button>',
				pagerNext:
					'<button aria-label="Volgende pagina" type="button" class="${classNames} c-back-button c-back-button--pagination" data-page="next"><svg class="c-back-button__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g transform="matrix(-1 0 0 1 48 0)" fill="none" fill-rule="evenodd"><circle class="c-back-button__circle" cx="24" cy="24" r="24"/><path class="c-back-button__arrow" fill-rule="nonzero" d="M34 23H17.8l5.6-5.6L22 16l-8 8 8 8 1.4-1.4-5.6-5.6H34z"/></g></svg></button>',
			},
		};

		if (!this.breakpoint.matches) {
			options = {
				...options,
				...paginationOptions,
			};
		}

		this.mixer = mixitup(this.el, options);
	}

	static init() {
		const els = document.querySelectorAll('[data-mixitup]');

		els.forEach((el) => new this(el));
	}
}
